export default {
  MY_APPLICATIONS ({ myApplications }) {
    return myApplications
  },
  APPLICATION_PROPERTY_TYPES ({ applicationPropertyTypes }) {
    return applicationPropertyTypes
  },
  APPLICATION_ADVANCED_TYPES ({ applicationAdvancedTypes }) {
    return applicationAdvancedTypes
  }
}
